import NotificationTypes from 'redux/notifications/types';

/** ****************************
 * fetch notifications action creators
 ***************************** */

 export const fetchNotifications = (data, cb) => ({
  type: NotificationTypes.FETCH_NOTIFICATION,
  payload: { data, cb },
});

export const fetchNotificationsSuccess = (notifications) => ({
  type: NotificationTypes.FETCH_NOTIFICATION_SUCCESS,
  payload: notifications,
});

export const fetchNotificationsFailure = (error) => ({
  type: NotificationTypes.FETCH_NOTIFICATION_FAILURE,
  payload: error,
});

/** ****************************
 * fetch more notifications action creators
 ***************************** */

 export const fetchMoreNotifications = (data, cb) => ({
  type: NotificationTypes.FETCH_MORE_NOTIFICATION,
  payload: { data, cb },
});

export const fetchMoreNotificationsSuccess = (notifications) => ({
  type: NotificationTypes.FETCH_MORE_NOTIFICATION_SUCCESS,
  payload: notifications,
});

export const fetchMoreNotificationsFailure = (error) => ({
  type: NotificationTypes.FETCH_MORE_NOTIFICATION_FAILURE,
  payload: error,
});

/** ****************************
 * read notification action creators
 ***************************** */

 export const readNotification = (data, cb) => ({
  type: NotificationTypes.READ_NOTIFICATION,
  payload: { data, cb },
});

export const readNotificationSuccess = (notifications) => ({
  type: NotificationTypes.READ_NOTIFICATION_SUCCESS,
  payload: notifications,
});

export const readNotificationFailure = (error) => ({
  type: NotificationTypes.READ_NOTIFICATION_FAILURE,
  payload: error,
});


/** ****************************
 * delete notifications action creators
 ***************************** */

 export const deleteNotification = (data, cb) => ({
  type: NotificationTypes.DELETE_NOTIFICATION,
  payload: { data, cb },
});

export const deleteNotificationSuccess = (notifications) => ({
  type: NotificationTypes.DELETE_NOTIFICATION_SUCCESS,
  payload: notifications,
});

export const deleteNotificationFailure = (error) => ({
  type: NotificationTypes.DELETE_NOTIFICATION_FAILURE,
  payload: error,
});


/** ****************************
 * new noitifications
 ***************************** */

 export const getNewNotifications = () => ({
  type: NotificationTypes.FETCH_NEW_NOTIFICATIONS
});

export const getNewNotificationsSuccess = (notifications) => ({
  type: NotificationTypes.FETCH_NEW_NOTIFICATIONS_SUCCESS,
  payload: notifications,
});

export const getNewNotificationsFailure = (error) => ({
  type: NotificationTypes.FETCH_NEW_NOTIFICATIONS_FAILURE,
  payload: error,
});

/** ****************************
 * open new notifications action creators
 ***************************** */

 export const openNewNotification = () => ({
  type: NotificationTypes.OPEN_NEW_NOTIFICATIONS,
});

export const openNewNotificationSuccess = () => ({
  type: NotificationTypes.OPEN_NEW_NOTIFICATIONS_SUCCESS,
});

export const openNewNotificationFailure = (error) => ({
  type: NotificationTypes.OPEN_NEW_NOTIFICATIONS_FAILURE,
  payload: error,
});